(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const mobileLayout = window.matchMedia('(max-width: 989px)');
  let keyboardInput = false;
  document.addEventListener('pointerdown', () => { keyboardInput = false; });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow')) keyboardInput = true;
  });

  function initializeMenus(root = document) {
    root.querySelectorAll('.site-header').forEach((header) => {
      if (header.dataset.menuReady) return;
      header.dataset.menuReady = 'true';

      const navRow = header.querySelector('.header__nav-row');
      const toggle = header.querySelector('.header__mobile-toggle');
      const menu = header.querySelector('.header__menu');
      const megaMenus = [...header.querySelectorAll('[data-mega-menu]')];
      const closeTimers = new WeakMap();
      const pointerInside = new WeakMap();
      const sync = (details) => details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
      const cancelClose = (details) => window.clearTimeout(closeTimers.get(details));
      const close = (details) => { cancelClose(details); details.open = false; sync(details); };
      const open = (details) => {
        cancelClose(details);
        megaMenus.forEach((other) => { if (other !== details) close(other); });
        details.open = true;
        sync(details);
      };
      const scheduleClose = (details) => {
        cancelClose(details);
        closeTimers.set(details, window.setTimeout(() => {
          if ((!keyboardInput || !details.contains(document.activeElement)) && !pointerInside.get(details)) close(details);
        }, 200));
      };
      const setMobileOpen = (open) => {
        navRow.dataset.mobileOpen = String(open);
        toggle.setAttribute('aria-expanded', String(open));
        if (!open) megaMenus.forEach(close);
      };

      toggle.addEventListener('click', () => setMobileOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      megaMenus.forEach((details) => {
        details.querySelector('summary').addEventListener('click', (event) => {
          if (desktopHover.matches) {
            event.preventDefault();
            if (details.open && keyboardInput) close(details);
            else open(details);
          }
        });
        details.querySelector('summary').addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            keyboardInput = true;
            open(details);
            details.querySelector('a')?.focus();
          }
        });
        details.addEventListener('pointerenter', (event) => {
          if (desktopHover.matches && event.pointerType === 'mouse') {
            pointerInside.set(details, true);
            open(details);
          }
        });
        details.addEventListener('pointerleave', (event) => {
          if (desktopHover.matches && event.pointerType === 'mouse') {
            pointerInside.set(details, false);
            scheduleClose(details);
          }
        });
        details.addEventListener('focusout', (event) => {
          if (!details.contains(event.relatedTarget)) scheduleClose(details);
        });
        details.addEventListener('toggle', () => {
          if (details.open && mobileLayout.matches) megaMenus.forEach((other) => { if (other !== details) close(other); });
          sync(details);
        });
        sync(details);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const activeMenu = megaMenus.find((details) => details.open);
        if (activeMenu) {
          event.preventDefault();
          if (activeMenu.contains(document.activeElement)) activeMenu.querySelector('summary').focus();
          close(activeMenu);
        } else if (mobileLayout.matches && toggle.getAttribute('aria-expanded') === 'true') {
          if (menu.contains(document.activeElement)) toggle.focus();
          setMobileOpen(false);
        }
      });
      mobileLayout.addEventListener('change', () => {
        setMobileOpen(false);
        megaMenus.forEach(close);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMenus());
  } else {
    initializeMenus();
  }
  document.addEventListener('shopify:section:load', (event) => initializeMenus(event.target));
})();
